import { impressOnBottom as d, impressOnTop as j, detectImpression as $ } from "../../common/detect-impression.js";
import { topIsInView as g, bottomIsInView as x } from "../../util/dom-utils.js";
import { logBannerImpressions as B } from "../log-banner-impressions.js";
import { BANNER_HTML_CLASS as I, BANNER_PLACEMENT_ID as k, CONTROL_BANNER_HTML_CLASS as q } from "./banner-to-html.js";
export function detectBannerImpressions() {
  var o = document.querySelectorAll(".".concat(I, ", .").concat(q)),
    t = [];
  for (var n = 0; n < o.length; n++) {
    var s = o[n],
      i = s.getAttribute(k);
    if (!i) continue;
    var m = $.oo(s),
      r = $.no(s);
    if (m && r) continue;
    var e = g(s),
      c = x(s);
    e && !m && j(s), c && !r && d(s), $.oo(s) && $.no(s) && t.push(i);
  }
  t.length > 0 && B(t);
}